/**
 * Bundle Stock Injector — injects a red "X LEFT" badge into each Kaching Bundles bar,
 * just below the image. The number is calculated from the global stock (`localStorage.ld_stock`,
 * same source as the top stock bar) divided by the per-bundle quantity detected from the bar's title.
 */
(function () {
  var STYLE_ID = 'ld-bundle-stock-style';
  if (!document.getElementById(STYLE_ID)) {
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.kaching-bundles__bar img,' +
      '.kaching-bundles__bar-image,' +
      '.kaching-bundles__free-gift__image,' +
      '.kaching-bundles__bar img.lazyload,' +
      '.kaching-bundles__bar img.lazyloaded {' +
      '  opacity: 1 !important;' +
      '  visibility: visible !important;' +
      '}' +
      '.ld-bundle-stock {' +
      '  color: #c00;' +
      '  font-weight: 800;' +
      '  text-align: center;' +
      '  font-size: 13px;' +
      '  text-transform: uppercase;' +
      '  letter-spacing: 0.5px;' +
      '  margin: 8px 0 4px 0;' +
      '  line-height: 1.2;' +
      '  display: block;' +
      '}' +
      '@media (max-width: 415px) {' +
      '  .ld-bundle-stock { font-size: 12px; margin: 6px 0 2px 0; }' +
      '}' +
      '@media (max-width: 335px) {' +
      '  .ld-bundle-stock { font-size: 10px; }' +
      '}';
    document.head.appendChild(style);
  }

  function detectBundleQty(bar) {
    var title = bar.querySelector('.kaching-bundles__bar-title');
    var text = title ? title.textContent : bar.textContent || '';
    var m = text.match(/(\d+)\s*pillow/i);
    if (m && +m[1] > 0) return +m[1];
    var m2 = text.match(/(?:x|qty|quantity)\s*[:#]?\s*(\d+)/i);
    if (m2 && +m2[1] > 0) return +m2[1];
    return 1;
  }

  function injectBadges() {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    if (!bars.length) return;
    var v = parseInt(localStorage.getItem('ld_stock'), 10);
    var totalStock = (isNaN(v) || v < 0) ? 9 : v;
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var qty = detectBundleQty(bar);
      var newText = Math.max(0, Math.floor(totalStock / qty)) + ' LEFT';
      var badge = bar.querySelector('.ld-bundle-stock');
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'ld-bundle-stock';
        var image = bar.querySelector('.kaching-bundles__bar-image');
        if (image && image.parentNode) {
          image.parentNode.insertBefore(badge, image.nextSibling);
        } else {
          var main = bar.querySelector('.kaching-bundles__bar-main') || bar;
          main.insertBefore(badge, main.firstChild);
        }
      }
      if (badge.textContent !== newText) badge.textContent = newText;
    }
  }

  function init() {
    injectBadges();
    setTimeout(injectBadges, 1000);
    // Poll ld_stock every 1s — the storage event does NOT fire in the same tab,
    // so we need to re-read localStorage to catch updates from fake-scarcity1.js.
    // Matches the pattern used by the inline ld-stock scripts in product templates.
    setInterval(injectBadges, 1000);
    // Conservative observer — only reacts to whole new bars being inserted
    // (variant switch), not to every sub-mutation. CRITICAL: avoids racing
    // with the Add-to-Cart flow.
    var pending = false;
    var observer = new MutationObserver(function (mutations) {
      if (pending) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          var isWholeBar =
            (n.classList && n.classList.contains('kaching-bundles__bar')) ||
            (n.querySelector && n.querySelector('.kaching-bundles__bar'));
          if (!isWholeBar) continue;
          pending = true;
          requestAnimationFrame(function () { pending = false; injectBadges(); });
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) {
      if (e.key === 'ld_stock') injectBadges();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
